import { defineMessages } from 'react-intl';
import { CombinedMeterModelDetails } from './meter_models/types';

export const Meter = defineMessages({
  meterLoadingError: {
    id: 'app.Meter.meterLoadingError',
  },
  noMeterFound: {
    id: 'app.Meter.noMeterFound',
  },
});

export const InventoryMeter = defineMessages({
  noInventoryMeterFound: {
    id: 'app.InventoryMeter.noInventoryMeterFound',
  },
});

export const InventoryMeters = defineMessages({
  noInventoryMetersFound: {
    id: 'app.InventoryMeters.noInventoryMetersFound',
  },
});

export const Meters = defineMessages({
  noMetersFound: {
    id: 'app.Meters.noMetersFound',
  },
});

export const InventoryLocations = defineMessages({
  noLocationsFound: {
    id: 'app.InventoryLocations.noLocationsFound',
  },
  noCombinedMetersFound: {
    id: 'app.InventoryLocations.noCombinedMetersFound',
  },
});

export const InventoryLocationBuildings = defineMessages({
  noBuildingsFound: {
    id: 'app.InventoryLocationBuildings.noBuildingsFound',
  },
});

export const MeterModels = defineMessages({
  warningMessage: {
    id: 'app.MeterModels.warningMessage',
    defaultMessage: 'Seznam modelů měřidel nahrán z interní databáze',
  },
  warningDescription: {
    id: 'app.MeterModels.warningDescription',
    defaultMessage: 'Zkontrolujte připojení k internetu',
  },
  errorMessage: {
    id: 'app.MeterModels.errorMessage',
    defaultMessage: 'Nepodařilo se stáhnout seznam modelů měřidel',
  },
  errorDescription: {
    id: 'app.MeterModels.errorDescription',
    defaultMessage: 'Neznámá chyba (modely měřidel)',
  },
});

export const MeterModelsDetails = defineMessages<keyof CombinedMeterModelDetails>({
  twin_meter: {
    id: 'app.common.twinMeter',
  },
  measurement_type: {
    id: 'app.MeterModelsDetails.measurement_type',
    defaultMessage: 'Typ měření',
  },
  measurement_category: {
    id: 'app.MeterModelsDetails.measurement_category',
    defaultMessage: 'Kategorie měření',
  },
  inbuilt_outputs: {
    id: 'app.MeterModelsDetails.inbuilt_outputs',
    defaultMessage: 'Vestavěné výstupy',
  },
  led_rate: {
    id: 'app.MeterModelsDetails.led_rate',
    defaultMessage: 'Frekvence LED',
  },
  programmable_pulses: {
    id: 'app.MeterModelsDetails.programmable_pulses',
    defaultMessage: 'Programovatelné pulzy',
  },
  pulse_rate: {
    id: 'app.MeterModelsDetails.pulse_rate',
    defaultMessage: 'Frekvence pulzů',
  },
  circuit_breaker_size: {
    id: 'app.MeterModelsDetails.circuit_breaker_size',
    defaultMessage: 'Velikost jističe',
  },
  device_category: {
    id: 'app.MeterModelsDetails.device_category',
    defaultMessage: 'Kategorie zařízení',
  },
  diameter_nominal: {
    id: 'app.MeterModelsDetails.diameter_nominal',
    defaultMessage: 'Jmenovitý průměr',
  },
  direct: {
    id: 'app.MeterModelsDetails.direct',
    defaultMessage: 'Přímé měření',
  },
  flange: {
    id: 'app.MeterModelsDetails.flange',
    defaultMessage: 'Příruba',
  },
  thermal_measurement_type: {
    id: 'app.MeterModelsDetails.thermal_measurement_type',
    defaultMessage: 'Typ měření tepla',
  },
  flowrate: {
    id: 'app.MeterModelsDetails.flowrate',
    defaultMessage: 'Průtok',
  },
  g_size: {
    id: 'app.MeterModelsDetails.g_size',
    defaultMessage: 'Velikost G',
  },
  hot_water: {
    id: 'app.MeterModelsDetails.hot_water',
    defaultMessage: 'Horká voda',
  },
  i_max: {
    id: 'app.MeterModelsDetails.i_max',
    defaultMessage: 'Maximální proud',
  },
  i_min: {
    id: 'app.MeterModelsDetails.i_min',
    defaultMessage: 'Minimální proud',
  },
  installation_position: {
    id: 'app.MeterModelsDetails.installation_position',
    defaultMessage: 'Instalační pozice',
  },
  lay_length: {
    id: 'app.MeterModelsDetails.lay_length',
    defaultMessage: 'Délka uložení',
  },
  resistance: {
    id: 'app.MeterModelsDetails.resistance',
    defaultMessage: 'Odpor',
  },
  i_ref: {
    id: 'app.MeterModelsDetails.i_ref',
    defaultMessage: 'Referenční proud',
  },
  mounting: {
    id: 'app.MeterModelsDetails.mounting',
    defaultMessage: 'Montáž',
  },
  orientation: {
    id: 'app.MeterModelsDetails.orientation',
    defaultMessage: 'Orientace',
  },
  phases: {
    id: 'app.MeterModelsDetails.phases',
    defaultMessage: 'Fáze',
  },
  p_max: {
    id: 'app.MeterModelsDetails.p_max',
    defaultMessage: 'Maximální výkon',
  },
  q_max: {
    id: 'app.MeterModelsDetails.q_max',
    defaultMessage: 'Maximální průtok',
  },
  q_min: {
    id: 'app.MeterModelsDetails.q_min',
    defaultMessage: 'Minimální průtok',
  },
  width: {
    id: 'app.MeterModelsDetails.width',
    defaultMessage: 'Šířka',
  },
  tariffs: {
    id: 'app.MeterModelsDetails.tariffs',
    defaultMessage: 'Tarify',
  },
  tube_material: {
    id: 'app.MeterModelsDetails.tube_material',
    defaultMessage: 'Materiál trubky',
  },
  woltman: {
    id: 'app.MeterModelsDetails.woltman',
    defaultMessage: 'Woltman',
  },
});

export const SynchronizeInstallationMeters = defineMessages({
  errorMessage: {
    id: 'app.SynchronizeInstallationMeters.errorMessage',
    defaultMessage: 'Při synchronizaci instalace měřidla {meterId} došlo k chybě',
  },
});

export const SynchronizeMeters = defineMessages({
  errorMessage: {
    id: 'app.SynchronizeMeters.errorMessage',
    defaultMessage: 'Při synchronizaci  měřidla {meterId} došlo k chybě',
  },
});

export const SynchronizeReplaceMeters = defineMessages({
  errorMessage: {
    id: 'app.SynchronizeReplaceMeters.errorMessage',
    defaultMessage: 'Při synchronizaci výměny měřidla {meterId} došlo k chybě',
  },
});
